import { render, staticRenderFns } from "./PriorPayrollPullout.vue?vue&type=template&id=47c42b1c&scoped=true&"
import script from "./PriorPayrollPullout.vue?vue&type=script&lang=js&"
export * from "./PriorPayrollPullout.vue?vue&type=script&lang=js&"
import style0 from "./PriorPayrollPullout.vue?vue&type=style&index=0&id=47c42b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c42b1c",
  null
  
)

export default component.exports